const newContainer = () => import("@/layouts/Default.vue");
const routerParent = () => import("@/layouts/routerParrent.vue");

const azmoonExecuteList = () =>
  import("../views/azmoon-execute/azmoon-execute-list/azmoonExecuteList.vue");
const azmoonExecuteUpdate = () =>
  import(
    "../views/azmoon-execute/azmoon-execute-update/azmoonExecuteUpdate.vue"
  );
const questionTitleList = () =>
  import("../views/question-title/questionTitleList.vue");

const answerOptionsList = () =>
  import("../views/answer-options/answerOptionsList.vue");
const examPackList = () => import("../views/exam-pack/examPackList.vue");

const questionList = () => import("../views/question-repo/questionList.vue");
const addQuestion = () =>
  import("../views/question-repo/components/addQuestion.vue");

const editQuestion = () =>
  import("../views/question-repo/components/editQuestion.vue");

const editExamPack = () =>
  import("../views/exam-pack/components/EditExamPack.vue");

const questionnaire = () =>
  import("@/modules/questionnaire/views/edit-questionnaire/index.vue");

export const azmoonRoutes: any[] = [
  {
    path: "/azmoon",
    name: "azmoon",
    meta: {
      label: "خانه",
      requiresAuth: true,
      moduleName: "azmoon",
    },
    component: newContainer,
    children: [
      {
        path: "question",
        name: "question",
        meta: {
          label: "مخزن سوال",
          requiresAuth: true,
          redesigned: true,
        },
        redirect: "/azmoon/question/list",
        component: routerParent,
        children: [
          {
            path: "list",
            name: "searchQuestion",
            component: questionList,
            meta: {
              label: "لیست سوال‌ها",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: "add",
            name: "addQuestions",
            component: addQuestion,
            meta: {
              label: "اضافه کردن سوال",
              requiresAuth: true,
            },
          },
          {
            path: "editQuestion/:id",
            name: "editStructureQuestion",
            component: editQuestion,
            meta: {
              label: "ویرایش سوال",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
      {
        path: "question-title",
        name: "title",
        meta: {
          label: "عنوان‌های سوال",
          requiresAuth: true,
          redesigned: true,
        },
        redirect: "/azmoon/question-title/list",
        component: routerParent,
        children: [
          {
            path: "list",
            name: "question-title-list",
            component: questionTitleList,
            meta: {
              label: "عنوان‌های سوال",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
      {
        path: "answer-options",
        name: "option",
        meta: {
          label: "گزینه‌های جواب",
          requiresAuth: true,
          redesigned: true,
        },
        redirect: "/azmoon/answer-options/list",
        component: routerParent,
        children: [
          {
            path: "list",
            name: "answer-options-list",
            component: answerOptionsList,
            meta: {
              label: "گزینه‌های جواب",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
      {
        path: "exam_pack",
        name: "exam_pack",
        meta: {
          label: "مخزن پرسشنامه",
          requiresAuth: true,
          redesigned: true,
        },
        redirect: "/azmoon/exam_pack/list",
        component: routerParent,
        children: [
          {
            path: "list",
            name: "search_exam_pack",
            component: examPackList,
            meta: {
              label: "لیست پرسشنامه‌ها",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: "edit/:id",
            name: "edit_exam_pack",
            component: editExamPack,
            meta: {
              label: "ویرایش پرسشنامه",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
      {
        path: "azmoon-execute",
        name: "azmoon_execute",
        meta: {
          label: " آزمون",
          requiresAuth: true,
          redesigned: true,
        },
        redirect: "/azmoon/azmoon-execute/list",
        component: routerParent,
        children: [
          {
            path: "list",
            name: "azmoon-execute-list",
            component: azmoonExecuteList,
            meta: {
              label: "اجرای آزمون",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: "update/:code",
            name: "azmoon-execute-update",
            component: azmoonExecuteUpdate,
            meta: {
              label: "ویرایش برگزاری آزمون",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":azmoonExecutePersonCode/questionnaire/:code/page/:pageCode/:attemptCode?",
            name: "azmoon-execute-questionnaire",
            component: questionnaire,
            meta: {
              label: "اجرای پرسشنامه",
              requiresAuth: true,
              redesigned: true,
              isPreviewMode: true,
              hasBottomNavigation: false,
              hasAudioNotification: false,
              hasMaxWidth: false,
              isPreviewHeader: false,
            },
          },
        ],
      },
    ],
  },
  {
    path: "/execute",
    name: "execute",
    meta: {
      label: "execute",
      requiresAuth: true,
    },
    // component: routerParent,
    redirect: "/execute/search",
    children: [
      {
        path: ":id/exam_pack/:exam_pack_id",
        name: "azmoon_execute_exam_pack",
        // component: executePage,
        meta: {
          label: "اجرای آزمون",
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: "/analysis-algorithm",
    name: "analysis_algorithm",
    meta: {
      label: "تعریف روش محاسبه",
      requiresAuth: true,
    },
    // component: newContainer,
    redirect: "/analysis-algorithm/search",
    children: [
      {
        path: "search",
        name: "search_analysis_algorithm",
        // component: SearchAnalysisAlgorithm,
        meta: {
          label: "لیست الگوریتم",
          requiresAuth: true,
        },
      },
      {
        path: "edit/:id",
        name: "edit_analysis_algorithm",
        // component: EditAnalysisAlgorithm,
        meta: {
          label: "ویرایش الگوریتم",
          requiresAuth: true,
        },
      },
    ],
  },
];
